import { render, staticRenderFns } from "./blessRewards.vue?vue&type=template&id=9cdc0e02&scoped=true&"
import script from "./blessRewards.vue?vue&type=script&lang=js&"
export * from "./blessRewards.vue?vue&type=script&lang=js&"
import style0 from "./blessRewards.vue?vue&type=style&index=0&id=9cdc0e02&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cdc0e02",
  null
  
)

component.options.__file = "blessRewards.vue"
export default component.exports